<template>
  <div class="content-warpper">
    <div class="warpper-title">
      <i class="iconfont iconiconfont-kemu-copy"></i>
      审核列表
    </div>
    <div class="padding-sm">
      <div class="flex align-center justify-between margin-bottom-sm">
        <div class="flex align-center condition-warpper">
          <el-select v-model="state" placeholder="请选择状态" class="margin-right-sm">
            <el-option
                v-for="item in stateList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          <el-input
              v-model="stu_name"
              placeholder="请输入姓名"
              class="margin-right-sm"
          ></el-input>
          <el-input
              v-model="stu_phone"
              placeholder="请输入手机号"
              class="margin-right-sm"
          ></el-input>
          <el-input
              v-model="stu_idcard"
              placeholder="请输入身份证号"
              class="margin-right-sm"
          ></el-input>

          <el-button type="primary" @click="onSearch">
            <p class="flex align-center font-size">
              <i class="el-icon-search margin-right-xs"></i>搜索
            </p>
          </el-button>
        </div>
      </div>
      <el-table
          :data="stuList"
          header-row-class-name="table-header"
          row-class-name="table-row"
          alig="center"
          fit
          style="width: 100%"
      >
        <el-table-column label="姓名">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.stu_name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="性别">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.stu_sex === 1 ? '男' : '女' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="身份证号">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.stu_idcard }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="手机号">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.stu_phone }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="准考证编号">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.student_exam_number }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <div class="table-item">
              <span v-if="scope.row.state === 0">待审核</span>
              <span v-if="scope.row.state >0 ">审核通过</span>
              <span v-if="scope.row.state < 0 ">审核拒绝</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="300">
          <template slot-scope="scope">
            <div class="table-operate">
              <router-link :to="'/coordinate/veridy5Student?id=' +scope.row.id " class="margin-right-xs">
                <el-button
                    size="medium"
                    type="primary"
                >查看
                </el-button>
              </router-link>
              <el-button
                  v-if="scope.row.state === 0"
                  size="medium"
                  type="primary"
                  @click="setItemStatus(scope.row.id,1)"
              >通过
              </el-button>
              <el-button
                  v-if="scope.row.state === 0"
                  size="medium"
                  type="danger"
                  @click="setItemStatus(scope.row.id,-1)"
              >拒绝
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          v-if="stuList.length > 0"
          class="page-all"
          background
          :current-page.sync="page"
          :page-size="limit"
          layout="prev, pager, next, jumper"
          :total="total"
      >
      </el-pagination>
    </div>
    <el-dialog
        :title="'拒绝原因'"
        :visible.sync="dialog2"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        width="600px"
        center>
      <el-form :model="accountForm" :rules="rules" ref="accountForm">
        <el-form-item label="" prop="name">
          <el-input type="textarea" v-model="accountForm.name" placeholder="请输入拒绝原因" rows="5"></el-input>
        </el-form-item>
        <el-form-item class="flex align-center justify-around" label-width="0">
          <el-button class="padding-lr-xl" @click="dialog2 = false">取消</el-button>
          <el-button class="padding-lr-xl" type="primary" @click="submitForm('accountForm')">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {setStateOne, xieExamStuList} from "@/api/coordinate";
export default {
  name: "verify5Detail",
  data() {
    return {
      id: '',
      orgid: '',
      page: 1,
      total: 0,
      limit: 10,
      stu_name: '',
      stu_phone: '',
      stu_idcard: '',
      state: 0,
      stateList: [
        {label: '待审核', value: 0},
        {label: '已通过', value: 1},
        {label: '未通过', value: -1},
      ],
      stuList: [],
      dialog2:false,
      setId:'',
      accountForm: {
        name: ''
      },
      rules: {
        name: [{required: true, message: '请输入拒绝原因', trigger: 'blur'}]
      },
    };
  },
  created() {
    this.$emit(
        "setIndex",
        '/coordinate/verify5',
        "当前位置：考生审核 > 审核列表",
        true
    );
    this.id = this.$route.query.id
    if (this.$route.query.orgid) this.orgid = this.$route.query.orgid
    if (this.$route.query.page) {
      this.page = Number(this.$route.query.page)
      this.stu_name = this.$route.query.stu_name
      this.stu_phone = this.$route.query.stu_phone
      this.stu_idcard = this.$route.query.stu_idcard
      this.state = Number(this.$route.query.state)
    }
    this.getList();
  },
  methods: {
    async getList() {
      let _list = await xieExamStuList(
          this.id,
          this.page,
          this.limit,
          this.orgid,
          this.stu_name,
          this.stu_phone,
          this.stu_idcard,
          this.state,
      );
      this.stuList = _list.data.list;
      this.total = _list.data.count;
      if(this.page>1&& this.stuList.length === 0){
        this.page--
      }
    },
    //  修改路径
    setPath() {
      this.$router.push({
        path: '/coordinate/verify5Detail',
        query: {
          id: this.id,
          orgid: this.orgid,
          page: this.page,
          stu_name: this.stu_name,
          stu_phone: this.stu_phone,
          stu_idcard: this.stu_idcard,
          state: this.state
        }
      })
    },
    onSearch() {
      if (this.page === 1) {
        this.setPath()
      } else {
        this.page = 1;
      }
    },
    setItemStatus(id,num) {
      this.$confirm(num === 1 ? "确定要通过吗？" : "确定要拒绝吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        if (num === 1) this.sureSet(id,num);
        if (num === -1) {
          this.dialog2 = true
          this.setId = id
        }
      });
    },
    async sureSet(id,num) {
      let _state = await setStateOne(id, num, '');
      this.getList()
      this.$message.success(_state.msg);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData(formName)
        }
      });
    },
    async submitData(formName) {
      let _state = await setStateOne(this.setId, -1, this.accountForm.name);
      this.$message.success(_state.msg)
      this.$refs[formName].resetFields();
      this.dialog2 = false
      this.setId = ''
      this.getList()
    }
  },
  watch: {
    page() {
      this.setPath()
    },
    $route() {
      this.getList();
    }
  }
}
</script>

<style scoped lang="scss">

</style>